import { useScreenSize } from '@ltvco/refresh-lib/utils';

import { constants } from 'appConstants';

import { withLegalIntelSection } from '../../CourtCases/constants';
import {
  ExploreByProductCategory,
  ExploreByProductCategoryStack,
} from '../components/ExploreByProductCategory';

import {
  ExploreByProductHeading,
  ExploreByProductSectionRoot,
} from './components';
import { EXPLORE_BY_PRODUCT_BLOCKS } from './constants';

export function LegalIntelligenceExploreByProductSection() {
  const { isMobile } = useScreenSize();
  const {
    imgIntellectualProperty,
    imgLegalIntelTop,
    imgLegalIntelBottom,
    imgLegalIntelTopMobile,
    imgLegalIntelBottomMobile,
  } = constants.images;
  const topSrc = isMobile
    ? imgLegalIntelTopMobile ?? ''
    : imgLegalIntelTop ?? '';
  const bottomSrc = isMobile
    ? imgLegalIntelBottomMobile ?? ''
    : imgLegalIntelBottom ?? topSrc;
  const illustrationSrc = {
    top: topSrc,
    bottom: bottomSrc,
    'intellectual-property': imgIntellectualProperty ?? '',
  } as const;
  const imageWidth = isMobile ? 328 : 389;
  const imageHeight = isMobile ? 121 : 245;

  return (
    <ExploreByProductSectionRoot
      component="section"
      aria-labelledby="legal-intelligence-explore-by-product-heading"
    >
      <ExploreByProductHeading
        id="legal-intelligence-explore-by-product-heading"
        component="h2"
        variant="h2"
      >
        Explore by Product
      </ExploreByProductHeading>

      {EXPLORE_BY_PRODUCT_BLOCKS.map(
        ({ id, illustration, legalIntelSection, links, ...category }) => (
          <ExploreByProductCategoryStack key={id}>
            <ExploreByProductCategory
              {...category}
              links={links.map(({ path, ...link }) => ({
                ...link,
                to: withLegalIntelSection(path, legalIntelSection),
              }))}
              imageSrc={illustrationSrc[illustration]}
              imageWidth={imageWidth}
              imageHeight={imageHeight}
            />
          </ExploreByProductCategoryStack>
        )
      )}
    </ExploreByProductSectionRoot>
  );
}
